import styled from 'styled-components'

export const TopImageWrapper = styled.section`
 width:100%;
 text-align:center;
`